import React, { useState, useMemo } from "react";
import DataTableComponent from "react-data-table-component";

const DataTable = ({
  columns,
  data,
  searchable = true,
  searchPlaceholder = "Search...",
  searchFields = [],
  paginationPerPage = 10,
  paginationRowsPerPageOptions = [10, 20, 30, 40, 50],
  onRowClick,
  customStyles = {},
  paginationServer = false, // Add this new prop
  onChangePage, // Add this new prop
  paginationTotalRows, // Add this new prop
  ...props
}) => {
  const [filterText, setFilterText] = useState("");

  const filteredItems = useMemo(() => {
    if (!data) return [];
    if (!filterText) return data;

    return data.filter((item) => {
      return searchFields.some((field) => {
        const value = item[field];
        return (
          value &&
          value.toString().toLowerCase().includes(filterText.toLowerCase())
        );
      });
    });
  }, [data, filterText, searchFields]);

  const defaultStyles = {
    headRow: {
      style: {
        backgroundColor: "#f8fafc",
        borderBottom: "2px solid #e2e8f0",
      },
    },
    headCells: {
      style: {
        fontSize: "14px",
        fontWeight: "bold",
        color: "#1e293b",
      },
    },
    cells: {
      style: {
        fontSize: "14px",
        color: "#475569",
      },
    },
    rows: {
      style: {
        minHeight: "52px",
        "&:nth-of-type(odd)": {
          backgroundColor: "#f8fafc",
        },
        "&:hover": {
          backgroundColor: "#f1f5f9",
        },
      },
    },
  };

  const subHeaderComponent = useMemo(() => {
    if (!searchable) return null;

    return (
      <div className="flex justify-between items-center p-4">
        <div className="relative">
          <input
            type="text"
            placeholder={searchPlaceholder}
            value={filterText}
            onChange={(e) => setFilterText(e.target.value)}
            className="w-64 px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-purpleColor"
          />
          <i className="fas fa-search absolute right-3 top-3 text-gray-400"></i>
        </div>
      </div>
    );
  }, [filterText, searchable, searchPlaceholder]);

  return (
    <DataTableComponent
      columns={columns}
      data={filteredItems}
      pagination
      paginationServer={paginationServer} // Pass the prop down
      paginationTotalRows={paginationTotalRows} // Pass the prop down
      onChangePage={onChangePage} // Pass the prop down
      paginationRowsPerPageOptions={paginationRowsPerPageOptions}
      subHeader={searchable}
      subHeaderComponent={subHeaderComponent}
      persistTableHead
      highlightOnHover
      pointerOnHover={!!onRowClick}
      onRowClicked={onRowClick}
      customStyles={{ ...defaultStyles, ...customStyles }}
      {...props}
    />
  );
};

export default DataTable;
